import * as ActionType from "../actionType";
import { fetchNewsPageApi } from "../../services/page/newspage";

const getNewsPageAction = () => {
  return async dispatch => {
    dispatchNewsPage(dispatch);
  };
};

const dispatchNewsPage = dispatch => {
  fetchNewsPageApi().then(data => {
    dispatch({
      type: ActionType.RECEIVE_NEWS_PAGE,
      data
    });
  });
};

export { getNewsPageAction, dispatchNewsPage };



// WEBPACK FOOTER //
// ./src/actions/page/newspage.js